module.exports = __webpack_public_path__ + "static/assets/4c4a76f108a96dfdb795fced1a0328f5.png";